export abstract class FnGridColumn {
	/** The name to render in the column header
	 *  colunn header name optional , will get from global config
	 */
	headerName?: string;

	/** CSS class for the header */
	headerClass?: string | string[] | ((params: any) => string | string[]);

	/** Tooltip for the column header */
	headerTooltip?: string;

	/** The unique ID to give the column. This is optional. If missing, the ID
	 *  will default to the field.
	 *  If both field and colId are missing, a unique ID will be generated.
	 *  This ID is used to identify the column in the API for sorting, filtering etc.
	 */

	colId?: string;

	/** If sorting by default, set it here. Set to 1 = 'asc' or 0 = 'desc' */
	sortValue?: number;

	actionSetupID?: string; // inline edit action setup ID
	cellClickSetupID?: string; // on cell click redirect or open modal

	// required
	// key: string; // first_name , formula:- laborCost
	/** The field of the row to get the cells data from */
	field: string;
	isFormula?: boolean;
	componentTypeID: string; // CURRENCY, NUMBER, TEXT,PHONENUMBER, LOOKUP,, COLOR,COMPARE_TO, CUSTOM--> need to be render

	componentID?: string; // will be use in custom component
	lookupArrayKey?: string; // could be from header or row , used only for LOOKUP
	//lookupKey?: string; // lookupKey in rowdata- like: {name:'jack',role:'crew',rolePK:1} -- rolePK is lookup key

	lookupIdKeyInRow?: string; // lookupIdKey in rowdata- like: {name:'jack',role:'crew',rolePK:1} -- rolePK is lookup key
	lookupDescKey?: string; // lookupDescKey is the ui-display in lookup Array

	dataType?: string; // Using in filter

	isEditDisable? = false;
	styleClass?: string; // UI
	isSortable = true;
	sortCls?: string;
	isHidden?: boolean;
	cellClass?: string;
	isInlineEditable?: boolean;
	isFilterEnable?: boolean;

	enableChageAcion?: boolean = false;
	enableBlurAcion?: boolean = false;
	enableFocusAcion?: boolean = false;
	enableSelectionChangeAcion?: boolean = false;
	enableClickAcion?: boolean = false;
	enableDbClickAcion?: boolean = false;
	pinTo? = 'none';
	isPinTo? = false;

	// lookupID?: string | number;
	// tslint:disable-next-line: ban-types
	cellStyleFormatting?: (colValue: any, field: string) => string; // cell style formatting on the basis of condition
	// tslint:disable-next-line: ban-types
	valueFormatter?: (rowValue: object, field: string) => string | number; // cell value formatting on the basis of conditions

	width?: string;
	autoWidth?: boolean = true;
}
